@if (magicSearchService.blueSearchResults() && magicSearchService.blueSearchResults()!.length > 0) {
<div class="w-full h-full overflow-y-auto min-h-0 scrollbar-hide" #blueScrollDiv infinite-scroll
    [infiniteScrollDistance]="scrollDistance" [infiniteScrollUpDistance]="scrollUpDistance"
    [infiniteScrollThrottle]="throttle" [infiniteScrollContainer]="blueScrollDiv" (scrolled)="onScrollDownBlue($event)">
    <ul role="list" class="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3">
        @for (creator of magicSearchService.blueSearchResults(); track $index) {
        <li class="card-animate" [style.animation-delay]="($index * 0.1) + 's'">
            <creator-card-blue [creator]="creator"></creator-card-blue>
        </li>
        }
    </ul>
</div>
}